import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { serverRenderedAt as serverRenderedAtSelector } from '~/App/shared/selectors/global';
import { useIsHydrated } from '~/App/shared/hooks/useIsHydrated';

export const useStableNow = (): number => {
  const isHydrated = useIsHydrated();
  const renderedAt = useSelector(serverRenderedAtSelector);

  return useMemo(() => {
    if (isHydrated || !renderedAt) {
      return Date.now();
    }

    return new Date(renderedAt).getTime();
  }, [isHydrated, renderedAt]);
};
